import styled from 'styled-components';

export const AttributionText = styled.div`
  font-size: 0.8em;
  color: #666;
  margin: 0.5em 0;
`;
